monthRangeSelector.$inject = ['$translate'];
export function monthRangeSelector($translate) {

  controller.$inject = ['$scope'];
  function controller($scope) {
    
    $scope.formatDate = formatDate;

    function formatDate(date) {
      if (date) {
        const monthIndex = date.getMonth();
        return $translate.instant('month/short/' + (1 + monthIndex)) + ' ' + date.getFullYear();
      } else {
        return '';
      }
    }
  }
  
  return {
    restrict: 'E',
    template: require('./month-range-selector.directive.html'),
    scope: {
      selector: '=' // A selector object from metric.controller.js
    },
    link: link,
    controller: controller
  };



  function link(scope, element, attrs) {

    // Let's disable editing the selected date with a keyboard,
    // so that we don't need to handle validation and parsing
    // (the formatting is configured in a run() block in app.js, by the way)
    element.find('input').prop('disabled', true);
  }
}

